import * as React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import routes from '../../routes';

interface Crumb {
  pathname: string;
  name: string;
  active: boolean;
}

/** Resolves crumb names by exact path match against src/routes.js (parameterized segments do not resolve). */
const getBreadcrumbs = (location: string): Crumb[] => {
  const crumbs: Crumb[] = [];
  location.split('/').reduce((prev, curr, index, array) => {
    const currentPathname = `${prev}/${curr}`;
    const route = routes.find((r: { path: string }) => r.path === currentPathname);
    if (route) {
      crumbs.push({ pathname: currentPathname, name: route.name, active: index + 1 === array.length });
    }
    return currentPathname;
  });
  return crumbs;
};

function AppBreadcrumb() {
  const { pathname } = useLocation();
  const crumbs = getBreadcrumbs(pathname);
  return (
    <Breadcrumbs aria-label='Breadcrumb' sx={{ fontSize: '0.875rem' }}>
      <Link component={RouterLink} to='/' underline='hover' color='inherit'>
        Home
      </Link>
      {crumbs.map((crumb) =>
        crumb.active ? (
          <Typography key={crumb.pathname} color='text.primary' sx={{ fontSize: '0.875rem', fontWeight: 500 }}>
            {crumb.name}
          </Typography>
        ) : (
          <Link key={crumb.pathname} component={RouterLink} to={crumb.pathname} underline='hover' color='inherit'>
            {crumb.name}
          </Link>
        )
      )}
    </Breadcrumbs>
  );
}

export default React.memo(AppBreadcrumb);
